import { BdkAiBadge } from '@breuni-ui/bdk-ai-badge';
import { safeDefine } from '@breuni-ui/safe-define';

safeDefine('ents-ai-badge', BdkAiBadge);
